<template>
  <PortalWidget :widget="widgetTitle">
    <div>
      <div
        v-if="!loading && !addButtonDisabled"
        class="m-b-15"
      >
        <button
          type="button"
          :disabled="addButtonDisabled"
          class="btn btn-success btn-sm"
          @click="displayNewForm"
        >
          <i class="fa fa-plus" />
          <span v-t="'ADD_MFA_METHOD'" />
        </button>
      </div>
      <v-table
        :data="enabledMFAMethods"
        :hide-sort-icons="true"
        class="table_beauty"
      >
        <thead slot="head">
          <tr>
            <v-th
              v-t="'PAGE_TITLE'"
              sort-key="type"
            />
            <v-th
              v-t="'ACTIONS'"
              sort-key="location"
            />
          </tr>
        </thead>
        <tbody
          slot="body"
          slot-scope="{ displayData }"
        >
          <tr
            v-if="showAddNewForm"
            class="row-inline-new-form slide-down bg-row-even"
          >
            <td colspan="100">
              <TwoFactorAuthMFAForm @hideDetailsForm="hideDetailsForm" />
            </td>
          </tr>
          <template
            v-for="row in displayData"
          >
            <tr
              :key="row.type"
            >
              <td>{{ row.label }}</td>
              <td>
                <div class="actions-collapsed-list">
                  <div class="action-icon">
                    <a
                      class="btn btn-list-function"
                      @click="onUpdateMethodClick(row)"
                    >
                      <i
                        v-tooltip.bottom.hover="{text:$t('MFA_ACTIONS_UPDATE'), transition: 0}"
                        class="typcn typcn-edit"
                        aria-hidden="true" 
                      />
                      <span
                        v-t="'UPDATE'"
                        class="hint-text-mobile"
                      />
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </v-table>

      <div
        v-if="loading"
        class="well well-sm text-center m-t-20"
      >
        <Loader />
        <span v-t="'TABLE_LOADING'" />
      </div>
      <div
        v-if="emptyMfaMethods"
        v-t="'MFA_METHODS_TABLE_EMPTY'"
        class="well well-sm text-center m-t-20"
      /> 
    </div>
  </PortalWidget>
</template>

<script>

import messages from './locales';
import sharedMessages from '@/core/locales';
import { mapActions, mapState, mapGetters } from 'vuex';
import PortalWidget from '@/core/components/PortalWidget.vue';
import TwoFactorAuthMFAForm from './TwoFactorAuthMFAForm';
import Loader from '@/core/components/Loader';
import { STATUS_PENDING, STATUS_SUCCESS, STATUS_ERROR, getStatus } from '@/store/helpers';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  name: 'TwoFactorProviders',

  components: {
    PortalWidget,
    Loader,
    TwoFactorAuthMFAForm
  },

  data() {
    return {
      showAddNewForm: false,
      widgetTitle: { title:this.$i18n.t('PAGE_TITLE'), iconClass: 'typcn typcn-key-outline'}
    };
  },

  computed: {
    ...mapState('twoFactorAuth', {
      actionStatus: (state) => getStatus(state, 'getTwoFactorMethods'),
      disableMFAStatus: state => getStatus(state, 'disableMFA')
    }),

    ...mapGetters('twoFactorAuth', [
      'enabledMFAMethods',
      'availableMFAMethods',
      'mfaMethodsList'
    ]),

    loading() {
      return this.actionStatus.status === STATUS_PENDING;
    },

    emptyMfaMethods() {
      return this.actionStatus.status === STATUS_SUCCESS && this.enabledMFAMethods && this.enabledMFAMethods.length === 0;
    },

    emptyMfaMethodsLeft() {
      return this.actionStatus.status === STATUS_SUCCESS && this.availableMFAMethods && this.availableMFAMethods.length === 0;
    },
    
    addButtonDisabled() {
      return this.showAddNewForm || this.emptyMfaMethodsLeft;
    }
  },

  created() {
    this.getTwoFactorMethods();
  },

  methods: {
    ...mapActions('twoFactorAuth', [
      'getTwoFactorMethods',
      'disableMFA', 
    ]),
    onUpdateMethodClick(row) {
      this.showAddNewForm = true;
    },

    displayNewForm() {
      this.showAddNewForm = true;
    },

    hideDetailsForm() {
      this.showAddNewForm = false;
    },

    handleActionStatus(action, successMessageKey) {
      if (action.status === STATUS_SUCCESS) {
        utilities.showToaster(STATUS_SUCCESS, this.$i18n.t(successMessageKey));
        this.hideDetailsForm();
      }
      if (action.status === STATUS_ERROR) {
        utilities.showToaster(STATUS_ERROR, action.error);
      }
    }
  },

  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style>

</style>